import { useEffect } from "react";
import { Outlet, useLocation } from "react-router-dom";
import Header from "./Header";
import Footer from "./Footer";
import { DynamicHead } from "@/components/DynamicHead";
import { LanguageProvider, useLanguage } from "@/contexts/LanguageContext";
import { useRealtimePresence } from "@/hooks/useRealtimePresence";
import { langFromPath } from "@/lib/services";

const PresenceTracker = () => {
  useRealtimePresence();
  return null;
};

/** Keep the language context in line with the language in the URL. */
const LangSync = () => {
  const { pathname } = useLocation();
  const { currentLanguage, setLanguage } = useLanguage();
  const urlLang = langFromPath(pathname);
  useEffect(() => {
    if (urlLang !== currentLanguage) setLanguage(urlLang);
    document.documentElement.lang = urlLang;
  }, [urlLang, currentLanguage, setLanguage]);
  useEffect(() => {
    document.body.classList.add("site-theme");
    return () => document.body.classList.remove("site-theme");
  }, []);
  return null;
};

const Layout = () => {
  return (
    <LanguageProvider>
      <LangSync />
      <DynamicHead />
      <PresenceTracker />
      <div className="site-theme flex min-h-screen flex-col bg-background text-foreground">
        <Header />
        <main className="flex-1">
          <Outlet />
        </main>
        <Footer />
      </div>
    </LanguageProvider>
  );
};

export default Layout;
